import { Component, OnInit } from '@angular/core'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { PriceQuoteStatusService } from '../../../core/services/price-quote/price-quote-status/price-quote-status.service'
import { PriceQuoteStatusEditComponent } from '../../../features/price-quote/price-quote-status-edit/price-quote-status-edit.component'
import { PriceQuoteStatusCreateComponent } from '../../../features/price-quote/price-quote-status-create/price-quote-status-create.component'
import { MatButton } from '@angular/material/button'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { ProposalClientCreateComponent } from '../../../features/proposal/proposal-client-create/proposal-client-create.component'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { convertCurrency } from '../../../shared/utils/utils'
import { ProposalClientEditComponent } from '../../../features/proposal/proposal-client-edit/proposal-client-edit.component'
import { downloadBase64File } from '../../../shared/utils/download_base64'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { ModalGoogleMapsComponent } from '../../../features/address/modal-google-maps/modal-google-maps.component'
import { ItinerariesItemProposalCreateFormComponent } from '../../../features/itineraries/item-proposal/itineraries-item-proposal-create/itineraries-item-proposal-create-form/itineraries-item-proposal-create-form.component'
import { PurchasesQuoteRequestService } from '../../../core/services/purchases/purchases-quote-request/purchases-quote-request.service'
import { PurchasesQuoteRequestCreateComponent } from '../../../features/purchases/purchases-quote-request/purchases-quote-request-create/purchases-quote-request-create.component'
import { TableListTariffComponent } from '../../../shared/components/table-list-tariff/table-list-tariff.component'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import { PurchasesQuoteSupplierService } from '../../../core/services/purchases/purchases-quote-supplier/purchases-quote-supplier.service'
import { PurchasesQuoteSupplierViewComponent } from '../../../features/purchases/purchases-quote-supplier/purchases-quote-supplier-view/purchases-quote-supplier-view.component'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { FormSearchProposalClientComponent } from '../../../shared/components/form-search-proposal-client/form-search-proposal-client.component'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { TableListProposalPageComponent } from '../../../shared/components/table-list-proposal-page/table-list-proposal-page.component'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { ModalMessageEmailComponent } from '../../../features/proposal/modal-message-email/modal-message-email.component'
import { ModalDownloadProposalComponent } from '../../../features/proposal/modal-download-proposal/modal-download-proposal.component'
import { TableListPurchasesQuoteSupplierPageComponent } from '../../../shared/components/table-list-purchases-quote-supplier-page/table-list-purchases-quote-supplier-page.component'
import { PurchasesQuoteSupplierTgViewComponent } from '../../../features/purchases/purchases-quote-supplier/purchases-quote-supplier-tg-view/purchases-quote-supplier-tg-view.component'
import { FormSearchQuoteTgComponent } from '../../../shared/components/form-search-quote-tg/form-search-quote-tg.component'

@Component({
  selector: 'purchases',
  imports: [
    FormSearchComponent,
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    PriceQuoteStatusCreateComponent,
    MatButton,
    FormClientSearchComponent,
    TableListTariffComponent,
    MatPaginatorModule,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    FormSearchProposalClientComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    TableListProposalPageComponent,
    TableListPurchasesQuoteSupplierPageComponent,
    FormSearchQuoteTgComponent,
  ],
  templateUrl: './purchases.component.html',
  styleUrl: './purchases.component.scss',
  providers: [ProposalClientService, AuthService],
  standalone: true,
})
export class PurchasesComponent implements OnInit {
  constructor(
    private purchasesQuoteSupplierService: PurchasesQuoteSupplierService,
    private snackbar: SnackbarCustomService,

    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  // searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  searchForm: any = { search: false, model: {} }
  inputSearch: string = ''

  /*
    propostaId	31
    tg	"TG25-0001"
    clienteId	13
    tipoPessoaId	2
    pessoaId	24
    nome	"Betina e Paulo Mudanças Ltda"
    cnpjCpf	"06840590000147"
    nomeEvento	"Evento Teste"
    dataEventoInicio	"17/08/2025"
    dataEventoFim	"17/08/2025"
    subClienteId	null
    subClienteTipoPessoaId	null
    subClientePessoaId	null
    subClienteNome	null
    subClienteCnpjCpf	null
    consultorId	136
    consultorNome	"Rita Rebeca Ferreira"
    consultorEmail	"rita_ferreira@danielvasconcelos.com.br"
    consultorComercialId	1
    consultorComercialPessoaId	10
    consultorComercialNome	"Gael Real"
    solicitante	"Rita Rebeca Ferreira"
    solicitanteEmail	"rita_ferreira@danielvasconcelos.com.br"
  */

  columns: any[] = [
    {
      keyColumn: 'tg_info',
      key: 'tg_info',
      description: 'Proposta',
    },
    {
      keyColumn: 'client_info',
      key: 'client_info',
      description: 'Cliente',
    },
    {
      keyColumn: 'consultant_info',
      key: 'consultant_info',
      description: 'Consultor',
    },
    {
      keyColumn: 'event_period',
      key: 'event_period',
      description: 'Período',
    },
    {
      keyColumn: 'action',
      key: {
        view: true,
      },
      description: 'Ações',
    },
  ]

  spinLoad: any = {
    contract: false,
    email: false,
    download: false,
    edit: false,
    manager: false,
    view: false,
    remove: false,
  }

  // screen: string = 'status cotação'
  screen: string = 'compras'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        // edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
        download: true,
        view: true,
        sendContract: true,
        sendEmail: true,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    this.page = 1
    this.searchForm = event
    if (event.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push({
          ...item,
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.purchasesQuoteSupplierService
      .listPagedPurchasesQuoteSupplierByTG(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.purchasesQuoteSupplierService
      .searchPagedPurchasesQuoteSupplierByTG(
        this.page,
        this.rows,
        this.searchForm.model,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  viewItem(item: any) {
    const dialogRef = this.dialog.open(PurchasesQuoteSupplierTgViewComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: item,
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
    console.log('item delete', item)
  }
}
